import React, { Component } from 'react';
import { useRefJs, loadJS } from '@platform/api';
const componentName = "business_component/print/print/main/index";
const url = "../../../../platform/resource/business_component/print/print/main/index.js";
useRefJs.setConfig({ [componentName]: url });

let PrintTemplate = useRefJs(["business_component/print/print/main/index"], function (Poc) {
    class PrintTemplate extends Component {
        constructor(props) {
            super(props);
        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc.PrintTemplate ref={forwardedRef} {...rest} /> 
        }
    }
    return React.forwardRef((props, ref) => {  
        return <PrintTemplate {...props} forwardedRef={ref} />;  
    });
});

export default PrintTemplate;

let print = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.print(...args);
    })
}

let printer = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.printer(...args);
    })
}
export { PrintTemplate, print, printer };
